export const maco = ({ dispatch, commit }, data) => {
  commit('LOGIN_MACO', data)
}

export const reset = ({commit}) => {
  commit('RESET')
}



// WEBPACK FOOTER //
// ./src/store/modules/tomaner/actions.js